<template>
	<div class="bhome">
		<div class="waits">
			<div class="wait w1">
				<div class="t_s">
					<div class="t">订单</div>
					<div class="s" @click="$router.push('./order/order')">更多<i class="el-icon-arrow-right"></i></div>
				</div>
				<div class="ChannelConfig">
					<div class="item" @click="$router.push({ path: './order/order', query: { order_status: 0 } })">
						<div class="num">{{wobj.unpay_order}}</div>
						<div class="text">未付款</div>
					</div>
					<div class="item" @click="$router.push({ path: './order/order', query: { order_status: 1 } })">
						<div class="num">{{wobj.paid_order}}</div>
						<div class="text">已付款</div>
					</div>
					<div class="item" @click="$router.push({ path: './order/order', query: { order_status: 3 } })">
						<div class="num">{{wobj.peihuo_order}}</div>
						<div class="text">配货中</div>
					</div>
					<div class="item" @click="$router.push({ path: './order/order', query: { order_status: 4 } })">
						<div class="num">{{wobj.send_order}}</div>
						<div class="text">已发货</div>
					</div>
					<div class="item" @click="$router.push({ name: 'border', params: { weifa: 1 } })">
						<div class="num">{{wobj.weifa}}</div>
						<div class="text">应发未发</div>
					</div>
				</div>
			</div>
			<div class="wait w2">
				<div class="t_s">
					<div class="t">售后</div>
					<div class="s" @click="$router.push('./order/service')">更多<i class="el-icon-arrow-right"></i></div>
				</div>
				<div class="ChannelConfig">
					<div class="item" @click="$router.push({ path: './order/service', query: { service_status: 1 } })">
						<div class="num">{{wobj.wait_service}}</div>
						<div class="text">未受理</div>
					</div>
					<div class="item" @click="$router.push({ path: './order/service', query: { service_status: 4 } })">
						<div class="num">{{wobj.accept_service}}</div>
						<div class="text">已受理</div>
					</div>
					<div class="item" @click="$router.push({ path: './order/service', query: { service_status: 5 } })">
						<div class="num">{{wobj.ing_service}}</div>
						<div class="text">处理中</div>
					</div>
					<div class="item" @click="$router.push({ path: './order/service', query: { service_status: 3 } })">
						<div class="num">{{wobj.reject_service}}</div>
						<div class="text">已拒绝</div>
					</div>
					<div class="item" @click="$router.push({ path: './order/service', query: { service_status: 7 } })">
						<div class="num">{{wobj.reject_refund_service}}</div>
						<div class="text">已拒退</div>
					</div>
				</div>
			</div>
			<div class="wait w3">
				<div class="t_s">
					<div class="t">工单</div>
					<div class="s" @click="$router.push('./order/work')">更多<i class="el-icon-arrow-right"></i></div>
				</div>
				<div class="ChannelConfig">
					<div class="item" @click="$router.push({ path: './order/work', query: { work_status: 1 } })">
						<div class="num">{{wobj.wait_work}}</div>
						<div class="text">待处理</div>
					</div>
				</div>
			</div>
		</div>

		<div class="tablediv">
			<div class="table">
				<div class="tdiv">
					<span>系统公告</span>
					<div class="filterdiv">
						<el-form :inline="true" :model="formfilter" class="demo-form-inline" size="mini" label-width="0">
							<el-form-item label="">
								<el-input v-model="formfilter.name" placeholder="标题"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="onfilter">查询</el-button>
								<el-button @click="onreset">重置</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<el-table :data="list" style="width: 100%" border height="calc(100% - 98px)">
					<el-table-column label="标题" align="left" header-align="center">
						<template slot-scope="scope">
							<div class="title" @click="oncontent(scope.row.id,1)">{{scope.row.name}}</div>
						</template>
					</el-table-column>
					<el-table-column label="日期" align="center" header-align="center" width="100px">
						<template slot-scope="scope">
							<div>{{scope.row.create_time_str?scope.row.create_time_str.split(" ")[0]:''}}</div>
						</template>
					</el-table-column>
				</el-table>

				<div class="pagediv">
					<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
						:current-page.sync="page" :page-size="pageSize" :total="total" v-if="total > 0"
						@current-change="handleCurrentChange" @size-change="handleSizeChange">
					</el-pagination>
				</div>
			</div>

			<div class="table">
				<div class="tdiv">
					<span>渠道公告</span>
					<div class="filterdiv">
						<el-form :inline="true" :model="formfilter1" class="demo-form-inline" size="mini" label-width="0">
							<el-form-item label="">
								<el-input v-model="formfilter1.name" placeholder="标题"></el-input>
							</el-form-item>
							<el-form-item>
								<el-button type="primary" @click="onfilter1">查询</el-button>
								<el-button @click="onreset1">重置</el-button>
							</el-form-item>
						</el-form>
					</div>
				</div>
				<el-table :data="list1" style="width: 100%" border height="calc(100% - 98px)">
					<el-table-column label="标题" align="left" header-align="center">
						<template slot-scope="scope">
							<div class="title" @click="oncontent(scope.row.id,2)">{{scope.row.name}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="create_time_str" label="日期" align="center" header-align="center" width="100px">
						<template slot-scope="scope">
							<div>{{scope.row.create_time_str?scope.row.create_time_str.split(" ")[0]:''}}</div>
						</template>
					</el-table-column>
					<el-table-column prop="shop_id_str" label="渠道" align="center" header-align="center" :show-overflow-tooltip="true" min-width="40px">
					</el-table-column>
				</el-table>

				<div class="pagediv">
					<el-pagination background layout="prev, pager, next, sizes, total" :page-sizes="[20, 30, 50, 100, 200]"
						:current-page.sync="page1" :page-size="pageSize1" :total="total1" v-if="total1 > 0"
						@current-change="handleCurrentChange1" @size-change="handleSizeChange1">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog :title="type == 1?'系统公告':'渠道公告'" :visible.sync="show" width="60%" :before-close="onclose">
			<div class="notice" v-if="show">
				<div class="h1">{{checkobj.name}}</div>
				<div class="time">{{checkobj.create_time_str}}</div>
				<div class="ql-editor" v-html="checkobj.content"></div>
				<div class="myjg" v-if="type == 2">温馨提示：任何脱离本平台的资金交易行为，均与本公司无任何关联，本公司不承担相关责任，请您谨慎操作，谨防风险。</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	export default {
		name: 'Bhome',
		data() {
			return {
				radio: 1,
				wobj: {},
				list: [],
				page: 1,
				pageSize: 20,
				total: 0,

				list1: [],
				page1: 1,
				pageSize1: 20,
				total1: 0,
				
				checkobj: {},
				show: false,
				type: 0,
				
				formfilter: {
					name: "",
				},
				
				formfilter1: {
					name: "",
				},
			}
		},

		mounted() {
			this.onwait();
			this.onlist();
			this.onlist1();
		},

		methods: {
			handleCurrentChange() {
				this.onlist();
			},

			handleSizeChange(val) {
				this.page = 1;
				this.pageSize = val;
				this.onlist();
			},

			handleCurrentChange1() {
				this.onlist1();
			},

			handleSizeChange1(val) {
				this.page1 = 1;
				this.pageSize1 = val;
				this.onlist1();
			},

			onwait() {
				this.$axios.get('api/user/buyer_wait_things').then(res => {
					if (res.data.code == 0) {
						this.wobj = res.data.data;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onlist() {
				var obj = JSON.parse(JSON.stringify(this.formfilter));
				obj.page = this.page;
				obj.limit = this.pageSize;

				this.$axios.post('api/user/buyer_sys_notice', obj).then(res => {
					if (res.data.code == 0) {
						this.total = res.data.data.count;
						this.list = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},

			onlist1() {
				var obj = JSON.parse(JSON.stringify(this.formfilter1));
				obj.page = this.page1;
				obj.limit = this.pageSize1;

				this.$axios.post('api/user/buyer_user_notice', obj).then(res => {
					if (res.data.code == 0) {
						this.total1 = res.data.data.count;
						this.list1 = res.data.data.list;
					} else {
						this.$message.error(res.data.message);
					}
				}).catch(err => {
					console.log(err)
				})
			},
			
			oncontent(id,n){
				var obj = {
					id: id
				};
				this.type = n;
				if(n == 1) {
					this.$axios.post('api/user/buyer_sys_notice', obj).then(res => {
						if (res.data.code == 0) {
							this.checkobj = res.data.data.list[0];
							this.show = true;
							this.$axios.post('api/user/add_sys_notice_view_num?id='+id);
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}
				
				if(n == 2) {
					this.$axios.post('api/user/buyer_user_notice', obj).then(res => {
						if (res.data.code == 0) {
							this.checkobj = res.data.data.list[0];
							this.show = true;
							this.$axios.post('api/user/add_user_notice_view_num?id='+id);
						} else {
							this.$message.error(res.data.message);
						}
					}).catch(err => {
						console.log(err)
					})
				}
			},
			
			onclose() {
				this.checkobj = {};
				this.type = 0;
				this.show = false;
			},
			
			onfilter() {
				this.page = 1;
				this.onlist();
			},
			
			onreset() {
				this.formfilter = {
					name: "",
				};
				this.page = 1;
				this.onlist();
			},
			
			onfilter1() {
				this.page1 = 1;
				this.onlist1();
			},
			
			onreset1() {
				this.formfilter1 = {
					name: "",
				};
				this.page1 = 1;
				this.onlist1();
			},
		}
	}
</script>

<style scoped lang="less">
	.bhome {
		width: 100%;
		height: 100%;
	}

	.waits {
		width: 100%;
		display: flex;

		.wait {
			// width: 300px;
			height: 150px;
			background: linear-gradient(180deg, #f5f9ff, #fff), linear-gradient(180deg, #f5f9ff, #fff), #fff;
			border-radius: 10px;
			margin-right: 15px;
			padding: 15px;
			box-sizing: border-box;
			display: flex;
			flex-direction: column;
			justify-content: space-between;

			.t_s {
				width: 100%;
				display: flex;
				align-items: center;
				justify-content: space-between;

				.t {
					font-size: 16px;
					font-weight: bolder;
				}

				.s {
					cursor: pointer;
					font-size: 12px;
				}
			}

			.ChannelConfig {
				width: 100%;
				height: 90px;
				display: flex;
				align-items: center;
				justify-content: center;

				.item {
					width: 90px;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					position: relative;

					.num {
						font-size: 24px;
						font-weight: bolder;
						cursor: pointer;
					}

					.text {
						padding-top: 5px;
						color: #666;
						font-size: 14px;
						cursor: pointer;
					}
				}

				.item::after {
					content: "";
					position: absolute;
					right: 0;
					height: 30px;
					width: 1px;
					background-color: #ececec;
				}

				.item:last-child::after {
					display: none;
				}
			}
		}

		.w1 {
			min-width: 320px;
			width: 40%;
		}

		.w2 {
			min-width: 300px;
			width: 40%;
		}

		.w3 {
			min-width: 150px;
			width: 20%;
		}
	}

	.tablediv {
		width: 100%;
		height: calc(100% - 160px);
		min-height: 300px;
		// background-color: #fff;
		margin-top: 10px;
		box-sizing: border-box;
		display: flex;
		justify-content: space-between;

		.table {
			width: calc(50% - 6px);
			height: 100%;
			margin-right: 12px;
			background-color: #fff;
			border-radius: 5px;
			padding: 12px 12px 0;
			box-sizing: border-box;

			.tdiv {
				width: 100%;
				height: 28px;
				margin-bottom: 12px;
				display: flex;
				align-items: center;
				span {
					font-size: 16px;
					font-weight: bolder;
					margin-right: 14px;
				}
				
				/deep/ .el-form-item--mini.el-form-item, .el-form-item--small.el-form-item {
					margin-bottom: 0 !important;
				}
			}
		}
	}

	.title {
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		color: #F65730;
		cursor: pointer;
	}
	
	.notice {
		.h1 {
			width: 100%;
			font-size: 20px;
			text-align: center;
			font-weight: bold;
			color: #303133;
		}
		
		.time {
			width: 100%;
			font-size: 14px;
			text-align: center;
			color: #666;
			margin-top: 12px;
		}
	}

</style>



// WEBPACK FOOTER //
// src/components/buyer/home.vue